var map = {
	"./level1/pic10-4.png": [
		43611,
		43611
	],
	"./level1/pic11-4.png": [
		96821,
		96821
	],
	"./level1/pic12-4.png": [
		32073,
		32073
	],
	"./level1/pic14-4.png": [
		79471,
		79471
	],
	"./level1/pic15-4.png": [
		25372,
		25372
	],
	"./level1/pic16-4.png": [
		13702,
		13702
	],
	"./level1/pic17-4.png": [
		70659,
		70659
	],
	"./level1/pic18-4.png": [
		80081,
		80081
	],
	"./level1/pic2-4.png": [
		46863,
		46863
	],
	"./level1/pic20-4.png": [
		96290,
		96290
	],
	"./level1/pic21-4.png": [
		29154,
		29154
	],
	"./level1/pic22-4.png": [
		7904,
		7904
	],
	"./level1/pic23-4.png": [
		25763,
		25763
	],
	"./level1/pic24-4.png": [
		2204,
		2204
	],
	"./level1/pic26-4.png": [
		49653,
		49653
	],
	"./level1/pic27-4.png": [
		43952,
		43952
	],
	"./level1/pic28-4.png": [
		60032,
		60032
	],
	"./level1/pic29-4.png": [
		42821,
		42821
	],
	"./level1/pic3-4.png": [
		18374,
		18374
	],
	"./level1/pic30-4.png": [
		20919,
		20919
	],
	"./level1/pic32-4.png": [
		85343,
		85343
	],
	"./level1/pic33-4.png": [
		39655,
		39655
	],
	"./level1/pic34-4.png": [
		7217,
		7217
	],
	"./level1/pic35-4.png": [
		2476,
		2476
	],
	"./level1/pic36-4.png": [
		51134,
		51134
	],
	"./level1/pic38-4.png": [
		50148,
		50148
	],
	"./level1/pic39-4.png": [
		85688,
		85688
	],
	"./level1/pic4-4.png": [
		72954,
		72954
	],
	"./level1/pic40-4.png": [
		36443,
		36443
	],
	"./level1/pic41-4.png": [
		33690,
		33690
	],
	"./level1/pic42-4.png": [
		34714,
		34714
	],
	"./level1/pic44-4.png": [
		2746,
		2746
	],
	"./level1/pic45-4.png": [
		27341,
		27341
	],
	"./level1/pic46-4.png": [
		58181,
		58181
	],
	"./level1/pic47-4.png": [
		76048,
		76048
	],
	"./level1/pic48-4.png": [
		33048,
		33048
	],
	"./level1/pic5-4.png": [
		77406,
		77406
	],
	"./level1/pic6-4.png": [
		63946,
		63946
	],
	"./level1/pic8-4.png": [
		42046,
		42046
	],
	"./level1/pic9-4.png": [
		75880,
		75880
	],
	"./level2/pic10-4.png": [
		73715,
		73715
	],
	"./level2/pic11-4.png": [
		83047,
		83047
	],
	"./level2/pic12-4.png": [
		72215,
		72215
	],
	"./level2/pic14-4.png": [
		99866,
		99866
	],
	"./level2/pic15-4.png": [
		5880,
		5880
	],
	"./level2/pic16-4.png": [
		79244,
		79244
	],
	"./level2/pic17-4.png": [
		16302,
		16302
	],
	"./level2/pic18-4.png": [
		53891,
		53891
	],
	"./level2/pic2-4.png": [
		33358,
		33358
	],
	"./level2/pic20-4.png": [
		42093,
		42093
	],
	"./level2/pic21-4.png": [
		28925,
		28925
	],
	"./level2/pic22-4.png": [
		1857,
		1857
	],
	"./level2/pic23-4.png": [
		69427,
		69427
	],
	"./level2/pic24-4.png": [
		18474,
		18474
	],
	"./level2/pic26-4.png": [
		8217,
		8217
	],
	"./level2/pic27-4.png": [
		30113,
		30113
	],
	"./level2/pic28-4.png": [
		2777,
		2777
	],
	"./level2/pic29-4.png": [
		69435,
		69435
	],
	"./level2/pic3-4.png": [
		91550,
		91550
	],
	"./level2/pic30-4.png": [
		80385,
		80385
	],
	"./level2/pic32-4.png": [
		17130,
		17130
	],
	"./level2/pic33-4.png": [
		55743,
		55743
	],
	"./level2/pic34-4.png": [
		58965,
		58965
	],
	"./level2/pic35-4.png": [
		33037,
		33037
	],
	"./level2/pic36-4.png": [
		19142,
		19142
	],
	"./level2/pic38-4.png": [
		71097,
		71097
	],
	"./level2/pic39-4.png": [
		10571,
		10571
	],
	"./level2/pic4-4.png": [
		87405,
		87405
	],
	"./level2/pic40-4.png": [
		43797,
		43797
	],
	"./level2/pic41-4.png": [
		95539,
		95539
	],
	"./level2/pic42-4.png": [
		12819,
		12819
	],
	"./level2/pic44-4.png": [
		46880,
		46880
	],
	"./level2/pic45-4.png": [
		90427,
		90427
	],
	"./level2/pic46-4.png": [
		28599,
		28599
	],
	"./level2/pic47-4.png": [
		17078,
		17078
	],
	"./level2/pic48-4.png": [
		38563,
		38563
	],
	"./level2/pic5-4.png": [
		41962,
		41962
	],
	"./level2/pic6-4.png": [
		99045,
		99045
	],
	"./level2/pic8-4.png": [
		708,
		708
	],
	"./level2/pic9-4.png": [
		3253,
		3253
	],
	"./level3/pic10-4.png": [
		4758,
		4758
	],
	"./level3/pic11-4.png": [
		37241,
		37241
	],
	"./level3/pic12-4.png": [
		37270,
		37270
	],
	"./level3/pic14-4.png": [
		22133,
		22133
	],
	"./level3/pic15-4.png": [
		10792,
		10792
	],
	"./level3/pic16-4.png": [
		10640,
		10640
	],
	"./level3/pic17-4.png": [
		9616,
		9616
	],
	"./level3/pic18-4.png": [
		52830,
		52830
	],
	"./level3/pic2-4.png": [
		46634,
		46634
	],
	"./level3/pic20-4.png": [
		1147,
		1147
	],
	"./level3/pic21-4.png": [
		27527,
		27527
	],
	"./level3/pic22-4.png": [
		60754,
		60754
	],
	"./level3/pic23-4.png": [
		25001,
		25001
	],
	"./level3/pic24-4.png": [
		16936,
		16936
	],
	"./level3/pic3-4.png": [
		36965,
		36965
	],
	"./level3/pic4-4.png": [
		55350,
		55350
	],
	"./level3/pic5-4.png": [
		70557,
		70557
	],
	"./level3/pic6-4.png": [
		70731,
		70731
	],
	"./level3/pic8-4.png": [
		47192,
		47192
	],
	"./level3/pic9-4.png": [
		80812,
		80812
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 25898;
module.exports = webpackAsyncContext;